import { z } from 'zod';

/** GET /geocode/reverse?lat&lon: the server looks the address up (and caches it). */
export const ReverseGeocodeQuery = z.object({
  lat: z.coerce.number().min(-90).max(90),
  lon: z.coerce.number().min(-180).max(180),
});

export const ReverseGeocodeResponse = z.object({
  /** e.g. "Westminster Bridge Road, Lambeth, London", or null when nothing was found. */
  address: z.string().nullable(),
  /**
   * ok: looked up (address may still be null). disabled: switched off on the server or
   * in your settings. unavailable: Nominatim is busy or unreachable; try again later.
   */
  status: z.enum(['ok', 'disabled', 'unavailable']),
});
export type ReverseGeocodeResponse = z.infer<typeof ReverseGeocodeResponse>;
